import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const TimeSheetTimeTypeForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'timetype'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'timetype.general.name_label',
            type: 'text',
            placeholder: 'timetype.general.name_placeholder',
        },
        { 
            type: 'dropdown', 
            name: 'type', 
            label: 'timetype.general.type_label', 
            disabled_selected: 'forms.select_type_disabled_selected',
            allowNoneOption: false,
            showSearch: false,
            hardcodedOptions: [
                { value: 'productive', name: 'timetype.type.productive'},
                { value: 'internal', name: 'timetype.type.internal'},
            ],
        },
        { 
            type: 'radio', 
            name: 'productive_subtype',
            label: 'timetype.general.productive_subtype_label', 
            tooltipText: 'timetype.general.productive_subtype_tooltip',
            dependentOn: { fieldName: 'type', value: 'productive' },
            options: [
                { value: 'work_time', name: 'timetype.productive_subtype.work_time'},
                { value: 'travel_time', name: 'timetype.productive_subtype.travel_time'},
            ],
        },
        {
            name: 'external_code',
            label: 'timetype.general.external_code_label',
            type: 'text',
            placeholder: 'timetype.general.external_code_placeholder',
            tooltipText: 'timetype.general.external_code_tooltipText'
        },
        {
            name: 'is_active',
            label: 'timetype.general.active_label',
            type: 'checkbox',
            showOnEdit: true,
        }
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default TimeSheetTimeTypeForm;